import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Fade from '@mui/material/Fade';
import PropTypes from 'prop-types';
import React from 'react';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Stepper from '@mui/material/Stepper';
import withStyles from '@mui/styles/withStyles';

import { goToStep, navigateSignin } from '../actions/stepper-actions';
import { setTestId } from '../util/testUtils';
import Invoice from './Invoice';
import PaymentForm from './PaymentForm';
import Review from './Review';
import status from '../constants/invoice-status';
import steps from '../constants/step-constants';

const styles = (theme) => ({
  root: {
    transitionDelay: '500ms',
  },
  stepper: {
    padding: theme.spacing(3, 0, 5),
  },
  divider: {
    margin: theme.spacing(1, 0, 1),
  },
});

const transitionDelay = {
  transitionDelay: '150ms',
};

const stepDefinitions = [
  {
    key: steps.INVOICE_DETAILS,
    label: 'Invoice Details',
    completed: 'isInvoiceComplete',
  },
  {
    key: steps.PAYMENT,
    label: 'Payment Details',
    completed: 'isPaymentComplete',
  },
  { key: steps.REVIEW, label: 'Review', completed: 'isPaid' },
];
class PortalStepper extends React.Component {
  static propTypes = {
    activeStep: PropTypes.oneOf(Object.values(steps)).isRequired,
    classes: PropTypes.object.isRequired,
    handleGoToStep: PropTypes.func.isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
    isPaid: PropTypes.bool.isRequired,
    isPayable: PropTypes.bool.isRequired,
    onNavigateSignin: PropTypes.func.isRequired,
  };

  // eslint-disable-next-line react/no-deprecated
  componentWillMount() {
    const { isAuthenticated, isPaid, onNavigateSignin } = this.props;

    // Prevent the user from returning here by pressing "Back" or attempting
    // to navigate directly
    if (!isAuthenticated || isPaid) {
      onNavigateSignin();
    }
  }

  getStepContent = (step) => {
    switch (step) {
      case steps.INVOICE_DETAILS:
        return <Invoice />;
      case steps.PAYMENT:
        return <PaymentForm />;
      case steps.REVIEW:
        return <Review />;
      default:
        throw new Error(`Unknown step ${step}`);
    }
  };

  handleStep = (step) => () => {
    const { handleGoToStep } = this.props;
    handleGoToStep(step);
  };

  render() {
    const { classes, activeStep, isAuthenticated, isPayable } = this.props;

    if (!isAuthenticated) {
      // Do not render until user authenticates
      return null;
    }

    const stepIndex = stepDefinitions.findIndex(
      (step) => step.key === activeStep
    );

    // TODO: show a special message when balance due is 0

    return (
      <Fade in style={transitionDelay}>
        <div>
          {isPayable && (
            <Stepper
              activeStep={stepIndex}
              alternativeLabel
              className={classes.stepper}
            >
              {stepDefinitions.map((step) => {
                const { [step.completed]: isCompleted } = this.props;
                return (
                  <Step
                    completed={isCompleted}
                    key={step.label}
                    onClick={this.handleStep(step.key)}
                    {...setTestId(
                      `step-${step.key}${isCompleted ? '-completed' : ''}`
                    )}
                  >
                    <StepLabel>{step.label}</StepLabel>
                  </Step>
                );
              })}
            </Stepper>
          )}
          {this.getStepContent(activeStep)}
        </div>
      </Fade>
    );
  }
}

function mapStateToProps(state) {
  const { invoice, payment, step } = state;

  // TODO: get isAuthenticated from the redux store

  return {
    isAuthenticated: step.isSignInComplete,
    isInvoiceComplete: step.isInvoiceComplete,
    isPaymentComplete: step.isPaymentComplete,
    isPayable: Boolean(!(invoice.invoiceStatusName === status.PAID)),
    isPaid: Boolean(payment.invoicePaymentId),
    activeStep: state.step.activeStep,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      handleGoToStep: goToStep,
      onNavigateSignin: navigateSignin,
    },
    dispatch
  );
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withStyles(styles)(PortalStepper))
);
